export const ADD_PRODUCT='ADD_PRODUCT';
export const FETCH_PRODUCT='FETCH_PRODUCT';
export const EDIT_PRODUCT='EDIT_PRODUCT';
export const UPDATE_PRODUCT='UPDATE_PRODUCT';
export const DELETE_PRODUCT='DELETE_PRODUCT';